import PropTypes from "prop-types";
import React, { useState } from "react";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import theme from "@/helpers/theme";

const MuiSwitchOld = ({
  label1,
  label2,
  selected,
  handleSwitchChange,
  sx,
  classes,
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        p: "0.25rem",
        justifyContent: "space-evenly",

        borderRadius: "2.5rem",
        backgroundColor: theme.palette.color.aigColor54,
        ...sx,
      }}
    >
      <Chip
        onClick={() => handleSwitchChange(label1)}
        label={label1}
        sx={{
          "&:hover": {
            backgroundColor:
              selected === label1
                ? theme.palette.color.aigColor1
                : theme.palette.color.aigColor54,
          },
          color:
            selected === label1
              ? theme.palette.color.aigColor37
              : theme.palette.color.aigColor11,
          minWidth: "5rem",
          backgroundColor:
            selected === label1
              ? theme.palette.color.aigColor1
              : theme.palette.color.aigColor54,
          fontSize: "0.875rem",
          fontWeight: selected === label1 ? "600" : "fontWeightMedium",
          flexGrow: 1,
          cursor: "pointer",

          ...classes,
        }}
      />
      <Chip
        onClick={() => handleSwitchChange(label2)}
        label={label2}
        sx={{
          "&:hover": {
            backgroundColor:
              selected === label2
                ? theme.palette.color.aigColor1
                : theme.palette.color.aigColor54,
          },
          color:
            selected === label1
              ? theme.palette.color.aigColor11
              : theme.palette.color.aigColor37,
          minWidth: "5rem",
          cursor: "pointer",
          backgroundColor:
            selected === label2
              ? theme.palette.color.aigColor1
              : theme.palette.color.aigColor54,
          fontSize: "0.875rem",
          fontWeight: selected === label1 ? "fontWeightMedium" : "600",
          flexGrow: 1,
          ...classes,
        }}
      />
    </Box>
  );
};

MuiSwitchOld.propTypes = {
  classes: PropTypes.object,
  handleSwitchChange: PropTypes.func,
  label1: PropTypes.string,
  label2: PropTypes.string,
  selected: PropTypes.string,

  sx: PropTypes.object,
};

export default MuiSwitchOld;
